import { DateUtils } from '@pbt/pbt-ui-components'

export type DateCellItem = {
  date: string
}

const DateCell = (item: DateCellItem) => DateUtils.formatDate(item.date)

export default DateCell
